import { DecisionSchema } from './decision';
import { LawTextSchema } from './lawText';

export * from './decision';
export * from './gender';
export * from './lawText';
export * from './schemaField';
export type Schemas = DecisionSchema | LawTextSchema;
